module.exports = "<div class=\"loader-container d-flex align-items-center justify-content-center\">\n    <span class=\"loader\"></span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/common/components/loader/loader.component.html
// module id = 632
// module chunks = 6